"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOktonGrid = exports.paginateOktonGrid = exports.OKTON_PAGE_SIZES = exports.sortOktonGrid = exports.oktonGridStartsDescending = exports.filterOktonGrid = void 0;
const react_1 = require("react");
function isEmpty(value) {
    return value === null || value === undefined || value === '';
}
const ACCENTS = new RegExp('[\\u0300-\\u036f]', 'g');
function normalize(text) {
    return text.normalize('NFD').replace(ACCENTS, '').toLowerCase();
}
function filterOktonGrid(items, columns, term) {
    const search = normalize(term.trim());
    if (search === '')
        return items;
    const readers = columns
        .filter(column => column.type !== 'date')
        .map(column => column.value)
        .filter((read) => Boolean(read));
    return items.filter(item => readers.some(read => {
        const value = read(item);
        return isEmpty(value)
            ? false
            : normalize(String(value)).includes(search);
    }));
}
exports.filterOktonGrid = filterOktonGrid;
function compare(a, b, type = 'text') {
    if (type === 'number')
        return Number(a) - Number(b);
    if (type === 'date') {
        return String(a) < String(b)
            ? -1
            : String(a) > String(b)
                ? 1
                : 0;
    }
    return String(a).localeCompare(String(b), 'pt-BR', {
        numeric: true,
    });
}
function oktonGridStartsDescending(column) {
    return column.type === 'date' || column.type === 'number';
}
exports.oktonGridStartsDescending = oktonGridStartsDescending;
function sortOktonGrid(items, column, desc) {
    const read = column.value;
    if (!read)
        return items;
    return items.slice().sort((a, b) => {
        const va = read(a);
        const vb = read(b);
        if (isEmpty(va) || isEmpty(vb)) {
            if (isEmpty(va) && isEmpty(vb))
                return 0;
            return isEmpty(va) ? 1 : -1;
        }
        const order = compare(va, vb, column.type);
        return desc ? -order : order;
    });
}
exports.sortOktonGrid = sortOktonGrid;
exports.OKTON_PAGE_SIZES = [10, 20, 30, 40, 50];
function paginateOktonGrid(items, page, pageSize) {
    const pageCount = Math.max(1, Math.ceil(items.length / pageSize));
    const validPage = Math.min(Math.max(page, 0), pageCount - 1);
    return {
        items: items.slice(validPage * pageSize, validPage * pageSize + pageSize),
        page: validPage,
        pageCount,
    };
}
exports.paginateOktonGrid = paginateOktonGrid;
function useOktonGrid(items, columns, search = '') {
    const [sort, setSort] = (0, react_1.useState)(null);
    const [page, setPage] = (0, react_1.useState)(0);
    const [pageSize, setPageSizeState] = (0, react_1.useState)(exports.OKTON_PAGE_SIZES[0]);
    const toggleSort = (key) => {
        const column = columns.find(current => current.key === key);
        if (!(column === null || column === void 0 ? void 0 : column.value))
            return;
        setSort(current => current && current.key === key
            ? { key, desc: !current.desc }
            : {
                key,
                desc: oktonGridStartsDescending(column),
            });
        setPage(0);
    };
    const filtered = (0, react_1.useMemo)(() => {
        const found = filterOktonGrid(items, columns, search);
        const column = sort
            ? columns.find(current => current.key === sort.key)
            : undefined;
        if (!sort || !column)
            return found;
        return sortOktonGrid(found, column, sort.desc);
    }, [items, columns, search, sort]);
    const slice = (0, react_1.useMemo)(() => paginateOktonGrid(filtered, page, pageSize), [filtered, page, pageSize]);
    return {
        sort,
        toggleSort,
        items: slice.items,
        filtered,
        page: slice.page,
        setPage,
        pageSize,
        setPageSize: (nextPageSize) => {
            setPageSizeState(nextPageSize);
            setPage(0);
        },
        pageCount: slice.pageCount,
    };
}
exports.useOktonGrid = useOktonGrid;
//# sourceMappingURL=grid.js.map